import httpClient from "./HttpClient";
import config from "@/assets/js/appsettings.json";
// Local dev: VUE_APP_API_URL (from .env.development.local, serve-only) overrides the baked API_URL.
// Unset in production builds → falls back to appsettings.json, so Azure bundles are unchanged.
const API_URL = process.env.VUE_APP_API_URL || config.API_URL;

export default class APIService {
  constructor() {}

  ///----------------------------------------------------------------
  /// Login
  ///----------------------------------------------------------------
  test() {
    const url = `/test/1`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Error Details
  ///----------------------------------------------------------------

  getErrorsUrl() {
    const url = `/error/logs`;
    return API_URL + url;
  }

  getErrors() {
    const url = `/error/logs`;
    return httpClient.get(url).then((response) => response.data);
  }

  getErrorDetails(data) {
    const url = `/error/${data.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Login
  ///----------------------------------------------------------------
  login(data) {
    const url = `/account/token/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  // Exchange a Microsoft (Entra ID) ID token for the portal's JWT (Sign in with Microsoft).
  microsoftLogin(idToken) {
    const url = `/account/MicrosoftToken`;
    return httpClient.post(url, { idToken }).then((response) => response.data);
  }

  register(data) {
    const url = `/account/register/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  reset(data) {
    const url = `/account/reset/${data}`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  createNewPassword(data) {
    const url = `/account/createnewpassword/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Users
  ///----------------------------------------------------------------

  getUsersUrl() {
    const url = `/user/`;
    return API_URL + url;
  }

  getUsers() {
    const url = `/user/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getUserTypes() {
    const url = `/user/GetRoleSelectItems`;
    return httpClient.get(url).then((response) => response.data);
  }

  getUser(data) {
    const url = `/user/${data.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  createUser(data) {
    const url = `/user/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  updateUser(data) {
    const url = `/user/${data.id}/`;
    return httpClient.put(url, data).then((response) => response.data);
  }

  changePassword(data) {
    const url = `/user/ChangePassword`
    return httpClient.post(url, data).then((response) => response)
  }

  deleteUser(data) {
    const url = `/user/${data.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Codes
  ///----------------------------------------------------------------

  getCountries() {
    const url = `/code/GetCountries/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getStatesByCountry(countryId) {
    const url = `/code/GetStatesByCountry/${countryId}`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Machine Details
  ///----------------------------------------------------------------

  getMachineUrl() {
    const url = `/machine/`;
    return API_URL + url;
  }

  getMachines() {
    const url = `/machine/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getMachinesList(data) {
    const url = `/machine/GetSelectItems/${data?.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  getMachineDetails(data) {
    let url = `/machine/${data.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  createMachine(data) {
    const url = `/machine/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  updateMachine(data) {
    const url = `/machine/${data.id}/`;
    return httpClient.put(url, data).then((response) => response.data);
  }

  deleteMachine(data) {
    const url = `/machine/${data.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  getAssemblyList(data) {
    const url = `/assembly/GetSelectItemsByMachine/${data.id}/${data.showAll}`;
    return httpClient.get(url).then((response) => response.data);
  }

  getSubAssemblyList(data) {
    const url = `/subassembly/GetSelectItemsByAssembly/${data.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  getCodeList() {
    const url = `/part/GetSelectItemsVS/`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Assembly Details
  ///----------------------------------------------------------------

  getAssembliesUrl() {
    const url = `/assembly/`;
    return API_URL + url;
  }

  getAssemblies() {
    const url = `/assembly/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getAssembliesList() {
    const url = `/assembly/GetSelectItems`;
    return httpClient.get(url).then((response) => response.data);
  }

  getAssembliesByMachineList(data) {
    const url = `/assembly/GetSelectItemsByMachine/${data.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  getAssemblyDetails(data) {
    const url = `/assembly/${data.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createAssembly(data) {
    const url = `/assembly/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  updateAssembly(data) {
    const url = `/assembly/${data.id}/`;
    return httpClient.put(url, data).then((response) => response.data);
  }

  // Account Setup → Utility Actions → Replace Charts: search any chart row
  // (assembly or sub-assembly) by machine/assembly/sub text or assembly #.
  chartSearch(term) {
    const url = `/assembly/chart-search?term=${encodeURIComponent(term || "")}`;
    return httpClient.get(url).then((response) => response.data);
  }

  deleteAssembly(data) {
    const url = `/assembly/${data.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  getSelectItemsByCompanyMachine(data) {
    const url = `/assembly/GetSelectItemsByCompanyMachine/${data.id}/${
      data.showAll
    }`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// SubAssembly Details
  ///----------------------------------------------------------------

  getSubAssembliesUrl() {
    const url = `/subassembly/`;
    return API_URL + url;
  }

  getSubAssemblies() {
    const url = `/subassembly/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getSubAssembliesList() {
    const url = `/subassembly/GetSelectItems`;
    return httpClient.get(url).then((response) => response.data);
  }

  getSubAssembliesByMachineList(data) {
    const url = `/subassembly/GetSelectItemsByMachine/${data.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  getSubAssemblyDetails(data) {
    const url = `/subassembly/${data.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createSubAssembly(data) {
    const url = `/subassembly/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  updateSubAssembly(data) {
    const url = `/subassembly/${data.id}/`;
    return httpClient.put(url, data).then((response) => response.data);
  }

  deleteSubAssembly(data) {
    const url = `/subassembly/${data.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Part Details
  ///----------------------------------------------------------------

  getPartsUrl() {
    const url = `/part/`;
    return API_URL + url;
  }

  getParts() {
    const url = `/part/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getPartsList() {
    const url = `/part/GetSelectItems`;
    return httpClient.get(url).then((response) => response.data);
  }

  getPartDetails(part) {
    const url = `/part/${part.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createPart(part) {
    const url = `/part/`;
    return httpClient.post(url, part).then((response) => response.data);
  }

  updatePart(part) {
    const url = `/part/${part.id}/`;
    return httpClient.put(url, part).then((response) => response.data);
  }

  deletePart(data) {
    const url = `/part/${data.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  getSelectItemsByAssembly(data) {
    const url = `/part/GetSelectItemsByAssembly/${data.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Wear Details
  ///----------------------------------------------------------------

  getWearUrl() {
    const url = `/wear/`;
    return API_URL + url;
  }

  getWears() {
    const url = `/wear/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getWearDetails(wear) {
    const url = `/wear/${wear.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createWear(wear) {
    const url = `/wear/`;
    return httpClient.post(url, wear).then((response) => response.data);
  }

  updateWear(wear) {
    const url = `/wear/${wear.id}/`;
    return httpClient.put(url, wear).then((response) => response.data);
  }

  deleteWear(wear) {
    const url = `/wear/${wear.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  getWearItems(wear) {
    const url = `/wear/GetItemsByAssembly/${wear.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Company Details
  ///----------------------------------------------------------------

  getCompanyUrl() {
    const url = `/company/`;
    return API_URL + url;
  }

  getCompanies() {
    const url = `/company/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getCompaniesList() {
    const url = `/company/GetSelectItems`;
    return httpClient.get(url).then((response) => response.data);
  }

  getCompanyDetails(company) {
    const url = `/company/${company.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createCompany(company) {
    const url = `/company/`;
    return httpClient.post(url, company).then((response) => response.data);
  }

  updateCompany(company) {
    const url = `/company/${company.id}/`;
    return httpClient.put(url, company).then((response) => response.data);
  }

  deleteCompany(company) {
    const url = `/company/${company.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Company Machine Details
  ///----------------------------------------------------------------

  getCompanyMachineUrl() {
    const url = `/companymachine/`;
    return API_URL + url;
  }

  getCompanyMachines() {
    const url = `/companymachine/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getCompanyMachineDetails(companyMachine) {
    const url = `/companymachine/${companyMachine.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createCompanyMachine(companyMachine) {
    const url = `/companymachine/`;
    return httpClient
      .post(url, companyMachine)
      .then((response) => response.data);
  }

  updateCompanyMachine(companyMachine) {
    const url = `/companymachine/${companyMachine.id}/`;
    return httpClient
      .put(url, companyMachine)
      .then((response) => response.data);
  }

  deleteCompanyMachine(companyMachine) {
    const url = `/companymachine/${companyMachine.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  getMachinesByCompany(data) {
    const url = `/CompanyMachine/GetSelectItems/${data.id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  //  Company Discount Details
  //-----------------------------------------------------------------

  getCompanyDiscountUrl() {
    const url = `/CompanyDiscount/`;
    return API_URL + url;
  }

  getCompanyPartsList(companyID, discountID, assemblyID) {
    const url = `/CompanyDiscount/GetPartList/${discountID}/${companyID}/${assemblyID}`;
    return httpClient.get(url).then((response) => response.data);
  }

  getCompanyDiscountDetails(id) {
    const url = `/CompanyDiscount/${id}`;
    return httpClient.get(url).then((response) => response.data);
  }

  createCompanyDiscount(data) {
    const url = `/CompanyDiscount/`;
    return httpClient.post(url, data).then((response) => response.data);
  }

  updateCompanyDiscount(discountID, data) {
    const url = `/CompanyDiscount/${discountID}`;
    return httpClient.put(url, data).then((response) => response.data);
  }

  deleteCompanyDiscount(companyID) {
    const url = `/CompanyDiscount/${companyID}`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Emails Details
  ///----------------------------------------------------------------

  getEmailsUrl() {
    const url = `/emailmanagement/`;
    return API_URL + url;
  }

  getEmails() {
    const url = `/emailmanagement/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getEmailDetails(email) {
    const url = `/emailmanagement/${email.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createEmail(email) {
    const url = `/emailmanagement/`;
    return httpClient.post(url, email).then((response) => response.data);
  }

  updateEmail(email) {
    const url = `/emailmanagement/${email.id}/`;
    return httpClient.put(url, email).then((response) => response.data);
  }

  deleteEmail(email) {
    const url = `/emailmanagement/${email.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Content Blocks Details
  ///----------------------------------------------------------------

  getContentBlockUrl() {
    const url = `/contentblock/`;
    return API_URL + url;
  }

  getContentBlocks() {
    const url = `/contentblock/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getContentBlockDetails(block) {
    const url = `/contentblock/${block.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createContentBlock(block) {
    const url = `/contentblock/`;
    return httpClient.post(url, block).then((response) => response.data);
  }

  updateContentBlock(block) {
    const url = `/contentblock/${block.id}/`;
    return httpClient.put(url, block).then((response) => response.data);
  }

  deleteContentBlock(block) {
    const url = `/contentblock/${block.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Page Details
  ///----------------------------------------------------------------

  getPagesUrl() {
    const url = `/page/`;
    return API_URL + url;
  }

  getPages() {
    const url = `/page/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getPagesDetails(page) {
    const url = `/page/${page.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createPages(page) {
    const url = `/page/`;
    return httpClient.post(url, page).then((response) => response.data);
  }

  updatePages(page) {
    const url = `/page/${page.id}/`;
    return httpClient.put(url, page).then((response) => response.data);
  }

  deletePages(page) {
    const url = `/page/${page.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Settings Details
  ///----------------------------------------------------------------

  getSettingsUrl() {
    const url = `/Settings/`;
    return API_URL + url;
  }

  getSettings() {
    const url = `/Settings/`;
    return httpClient.get(url).then((response) => response.data);
  }

  getCompanySettings() {
    const url = `/Settings/Company`;
    return httpClient.get(url).then((response) => response.data);
  }

  getSettingDetail(setting) {
    const url = `/Settings/${setting.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  updateSetting(setting) {
    const url = `/Settings/${setting.id}/`;
    return httpClient.put(url, setting).then((response) => response.data);
  }

  updateCompanySettings(settings) {
    const url = `/Settings/Company`;
    return httpClient.put(url, settings).then((response) => response.data);
  }

  updateSettings(settings) {
    const url = `/Settings/`;
    return httpClient.put(url, settings).then((response) => response.data);
  }

  getTimeZones() {
    const url = `/code/GetTimeZones`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Navigation Details
  ///----------------------------------------------------------------

  getNavigationUrl() {
    const url = `/navigation/`;
    return API_URL + url;
  }

  getUserHeaderNavigation() {
    const url = `/navigation/gettree/?type=header`;
    return httpClient.get(url).then((response) => response.data);
  }

  getUserFooterNavigation() {
    const url = `/navigation/gettree/?type=footer`;
    return httpClient.get(url).then((response) => response.data);
  }

  getHeaderNavigation() {
    const url = `/navigation/?type=header`;
    return httpClient.get(url).then((response) => response.data);
  }

  getFooterNavigation() {
    const url = `/navigation/?type=footer`;
    return httpClient.get(url).then((response) => response.data);
  }

  // Master-only. Role names for the Menu Navigation pickers, derived server-side from
  // Roles.AnyRole so Constants.cs stays the single source of truth — the list used to be
  // hardcoded in the Vue component and silently went stale when Manufacturing and Foundry
  // were added for Report Access, which is what made those roles impossible to target.
  getNavigationRoleNames() {
    const url = `/navigation/Roles`;
    return httpClient.get(url).then((response) => response.data);
  }

  getNavigationSelectedItems() {
    const url = `/navigation/GetSelectItems`;
    return httpClient.get(url).then((response) => response.data);
  }

  getNavigationDetails(nav) {
    const url = `/navigation/${nav.id}/`;
    return httpClient.get(url).then((response) => response.data);
  }

  createNavigation(nav) {
    const url = `/navigation/`;
    return httpClient.post(url, nav).then((response) => response.data);
  }

  updateNavigation(data) {
    const url = `/navigation/${data.id}/`;
    return httpClient.put(url, data).then((response) => response.data);
  }

  // Master-only: users of a company (+ their role) for the report's "View as user" preview.
  getCompanyUsers(companyId) {
    return httpClient.get(`/user/company-users?companyId=${companyId}`).then((response) => response.data);
  }

  deleteNavigation(nav) {
    const url = `/navigation/${nav.id}/`;
    return httpClient.delete(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Sales Territory (admin-managed State -> Territory -> Sales Rep;
  /// drives the Customer Insights territory map)
  ///----------------------------------------------------------------

  getSalesTerritories() {
    const url = `/report/sales-territory`;
    return httpClient.get(url).then((response) => response.data);
  }

  createSalesTerritory(row) {
    const url = `/report/sales-territory`;
    return httpClient.post(url, row).then((response) => response.data);
  }

  updateSalesTerritory(row) {
    const url = `/report/sales-territory/${row.id}`;
    return httpClient.put(url, row).then((response) => response.data);
  }

  deleteSalesTerritory(row) {
    const url = `/report/sales-territory/${row.id}`;
    return httpClient.delete(url).then((response) => response.data);
  }

  // Bulk replace the whole Sales Territories map from an imported CSV. rows = [{state,territory,salesRep,color}].
  importSalesTerritories(rows) {
    const url = `/report/sales-territory/import`;
    return httpClient.post(url, { rows }).then((response) => response.data);
  }

  // Per-customer territory exceptions (override the Customer-ID-prefix auto-assign rule).
  getTerritoryExceptions() {
    return httpClient.get(`/report/territory-exception`).then((response) => response.data);
  }
  createTerritoryException(row) {
    return httpClient.post(`/report/territory-exception`, row).then((response) => response.data);
  }
  updateTerritoryException(row) {
    return httpClient.put(`/report/territory-exception/${row.id}`, row).then((response) => response.data);
  }
  deleteTerritoryException(row) {
    return httpClient.delete(`/report/territory-exception/${row.id}`).then((response) => response.data);
  }
  // Bulk replace ALL exceptions from an imported config file. rows = [{customerId,shipCountry,shipZip,territory,salesRep,isActive}].
  importTerritoryExceptions(rows) {
    return httpClient.post(`/report/territory-exception/import`, { rows }).then((response) => response.data);
  }
  // Distinct past ship-to (country, zip) pairs for a customer — populates the exception editor's dropdowns.
  getExceptionShipTos(customerId) {
    return httpClient
      .get(`/report/territory-exception/ship-tos`, { params: { customerId } })
      .then((response) => response.data);
  }

  // Sales Territories: the Customer-ID-prefix auto-match toggle (on/off, persisted server-side in rpt_Setting).
  getTerritoryAutoAssign() {
    return httpClient.get(`/report/territory-auto-assign`).then((response) => response.data);
  }
  setTerritoryAutoAssign(on) {
    return httpClient.post(`/report/territory-auto-assign`, { on: !!on }).then((response) => response.data);
  }
  // Rep aliases: departed/alternate rep name -> current rep (Sales Territories).
  getRepAliases() {
    return httpClient.get(`/report/rep-alias`).then((response) => response.data);
  }
  createRepAlias(row) {
    return httpClient.post(`/report/rep-alias`, row).then((response) => response.data);
  }
  deleteRepAlias(id) {
    return httpClient.delete(`/report/rep-alias/${id}`).then((response) => response.data);
  }
  // Bulk replace ALL rep aliases from an imported config file. rows = [{aliasName,canonicalName}].
  importRepAliases(rows) {
    return httpClient.post(`/report/rep-alias/import`, { rows }).then((response) => response.data);
  }
  // Unmapped-rep warnings for the Sales Territories section (reps on orders that match no assignment).
  getTerritoryWarnings() {
    return httpClient.get(`/report/sales-territory/warnings`).then((response) => response.data);
  }
  dismissTerritoryWarning(name) {
    return httpClient.post(`/report/sales-territory/warnings/dismiss`, { name }).then((response) => response.data);
  }
  restoreTerritoryWarning(name) {
    return httpClient.post(`/report/sales-territory/warnings/restore`, { name }).then((response) => response.data);
  }
  // Unmapped-rep DRILL-DOWN: a rep's orders grouped by (prefix + customer country), lazy on rep-expand.
  getTerritoryWarningGroups(rep) {
    return httpClient.get(`/report/sales-territory/warning-groups`, { params: { rep } }).then((response) => response.data);
  }
  // ...and the orders behind one (rep, prefix, country) group, lazy on group-expand.
  getTerritoryWarningOrders(rep, prefix, country) {
    return httpClient.get(`/report/sales-territory/warning-orders`, { params: { rep, prefix, country } }).then((response) => response.data);
  }

  // Territory → logins (emails) link, edited from the Sales Territories grid (territory side).
  // Same rpt_UserTerritory rows as the per-user editor in Account Setup → Users.
  getTerritoryUsers() {
    const url = `/report/territory-users`;
    return httpClient.get(url).then((response) => response.data);
  }

  setTerritoryUsers(payload) {
    const url = `/report/territory-users`;
    return httpClient.post(url, payload).then((response) => response.data);
  }

  // Territory-access logins that have no portal account yet (added but never signed in) — powers the
  // "pending provisioning" readout under the Territory Access grid.
  getTerritoryPending() {
    const url = `/report/territory-users/pending`;
    return httpClient.get(url).then((response) => response.data);
  }

  // Report Access — which logins (emails) can see each report ("Sales Insights" / "Manufacturing Insights").
  // Mirrors Territory Access; rows live in rpt_UserReportAccess and provision a role on first sign-in.
  getReportUsers() {
    const url = `/report/report-users`;
    return httpClient.get(url).then((response) => response.data);
  }

  setReportUsers(payload) {
    const url = `/report/report-users`;
    return httpClient.post(url, payload).then((response) => response.data);
  }

  // Replace one report's assigned Entra security groups + sync their resolved membership
  // (memberEmails come from Microsoft Graph in the admin's browser).
  setReportGroups(payload) {
    const url = `/report/report-groups`;
    return httpClient.post(url, payload).then((response) => response.data);
  }

  // Same for one TERRITORY's assigned Entra groups (Territory Access on Sales/Customer Insights).
  setTerritoryGroups(payload) {
    const url = `/report/territory-groups`;
    return httpClient.post(url, payload).then((response) => response.data);
  }

  // Report-access logins with no portal account yet — powers the "pending provisioning" readout.
  getReportPending() {
    const url = `/report/report-users/pending`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Sequence Details
  ///----------------------------------------------------------------

  getSequenceUrl() {
    const url = `/sequence/`;
    return API_URL + url;
  }

  getSequence() {
    const url = `/sequence/`;
    return httpClient.get(url).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// Machine Import
  ///----------------------------------------------------------------
  getImportUrl() {
    const url = `/import/`;
    return API_URL + url;
  }

  importFile(file) {
    const url = `/import/`;
    httpClient.defaults.headers["Content-Type"] = "multipart/form-data";
    return httpClient.post(url, file).then((response) => response.data);
  }

  ///----------------------------------------------------------------
  /// ModuleNameHere
  ///----------------------------------------------------------------

  ///----------------------------------------------------------------
  /// Submit Bug Reports
  ///----------------------------------------------------------------
  submitBug(data) {
    const url = "/Email";
    httpClient.defaults.headers["Content-Type"] = "multipart/form-data";
    return httpClient.post(url, data).then((response) => response.data);
  }
}
